import { useAppDispatch } from '../../../../../redux/hooks'
import { FC, memo, MouseEvent, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { encodeToBase64 } from '../../../../../utils/encoding-utils'
import { Container, Icon, Input, Label, Text } from './checkbox-radio-filter-styles'
import { FilterItemTransport } from '../../../../../transports/filters-configuration-transport'
import { FilterType } from '../../types'
import { filterGATracking, preventEvent } from '../../utils'
import { filterClick, getRegionNodeId } from '../../../../../redux/filters'

import { useRequestUserConfigContext } from '../../../../../hooks/request'

import RadioSelectedIcon from '../../../../../assets/icons/filter-icons/radio-selected.svg'
import type { StyledSvgComponent } from '../../../../../types/svg'

type Props = {
    onFilterItemClick: (selectedFilterItemPosition: any) => void
    filterItem: FilterItemTransport
    filterItemPosition: number
    filterType: FilterType
    isFilterItemSelected: boolean
    shouldCommit?: boolean
}

const RadioFilterItem: FC<Props> = ({
    onFilterItemClick,
    filterItem,
    filterItemPosition,
    filterType,
    isFilterItemSelected,
    shouldCommit = false,
}) => {
    const dispatch = useAppDispatch()
    const regionNodeId = useSelector(getRegionNodeId)
    const user = useRequestUserConfigContext()
    const isDisabled = filterItem.count < 1

    const handleClick = useCallback(
        (event: MouseEvent<HTMLElement>) => {
            preventEvent(event)
            if (isDisabled) {
                return
            }
            filterGATracking({
                type: filterType,
                name: filterItem.title,
                value: filterItem.value,
                isChecked: !isFilterItemSelected,
                regionNodeId,
            })
            onFilterItemClick(filterItemPosition)
            const filterItemUrl = new URL(filterItem.absoluteLink)
            dispatch(filterClick(encodeToBase64(filterItemUrl.pathname + filterItemUrl.search), shouldCommit, user))
        },
        [
            onFilterItemClick,
            filterItemPosition,
            filterItem,
            filterType,
            isFilterItemSelected,
            isDisabled,
            dispatch,
            regionNodeId,
            shouldCommit,
            user,
        ],
    )

    return (
        <Container onClick={handleClick} isMultiSelect={false} $disabled={isDisabled}>
            <Text>{filterItem.title}</Text>
            <Label $checked={isFilterItemSelected} isMultiSelect={false}>
                {isFilterItemSelected && (
                    <Icon $type="radio" as={RadioSelectedIcon as StyledSvgComponent} aria-label="radio selector" />
                )}
                <Input type="radio" name={filterType} defaultChecked={isFilterItemSelected} />
            </Label>
        </Container>
    )
}

export default memo(RadioFilterItem)
